<template>
  <div class="d-flex flex-column scroll py-2 h-100 px-5" style="max-height: 65vh">
    <BaseTree ref="tree" :defaultOpen="false" class="mtl-tree w-100"  v-model="treeData" treeLine>
      <template #default="{ node, stat, index }">
        <div class="doors"
             :class="{ 'selected': selected === node.id }">
          <div v-if="stat.children?.length || stat.doors?.length"
               class="open_icon_container bg-hover-light-info"
               @click.native="stat.open = !stat.open ">
            <i style="font-size: .8rem" class="fa icon" :class="{ 'fa-plus': !stat.open, 'fa-minus': stat.open }"></i>
          </div>
          <div @click.prevent.stop="toggleSelected(node)" class="w-100"
               :style="{ 'padding-left': `${(stat.level * 20) + ((!node.children.length) ? 20 : 0)}px` }"
          >
            <Card class="card shadow-sm border bg-hover-light-info p-0 mb-2 min-w-250px mw-100">
              <div class="card-body p-0">
                <div class="d-flex flex-row h-50px">
                  <div class="door_icon_container">
                    <i v-if="node.isDoor" class="fa icon fs-2">
                      <svg width="22" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.961921 17C0.819921 17 0.700921 16.952 0.604921 16.856C0.508921 16.76 0.461254 16.641 0.461921 16.499C0.462588 16.357 0.510254 16.2383 0.604921 16.143C0.699588 16.0477 0.818588 16 0.961921 16H1.99992V2.116C1.99992 1.67133 2.15825 1.291 2.47492 0.975C2.79159 0.659 3.17159 0.500667 3.61492 0.5H12.3849C12.8289 0.5 13.2089 0.658333 13.5249 0.975C13.8409 1.29167 13.9993 1.67167 13.9999 2.115V16H15.0389C15.1803 16 15.2989 16.048 15.3949 16.144C15.4909 16.24 15.5386 16.359 15.5379 16.501C15.5373 16.643 15.4896 16.7617 15.3949 16.857C15.3003 16.9523 15.1813 17 15.0379 17H0.961921ZM12.9999 16V2.116C12.9999 1.936 12.9423 1.78833 12.8269 1.673C12.7116 1.55767 12.5643 1.5 12.3849 1.5H8.84592V1.016C9.46392 1.08467 9.97725 1.35 10.3859 1.812C10.7946 2.274 10.9993 2.81233 10.9999 3.427V14.739C10.9999 15.1417 10.8609 15.4993 10.5829 15.812C10.3049 16.1247 9.96259 16.3033 9.55592 16.348V16H12.9999ZM7.00992 9.77C7.22259 9.77 7.40225 9.69333 7.54892 9.54C7.69559 9.38667 7.76892 9.20333 7.76892 8.99C7.76892 8.77667 7.69525 8.597 7.54792 8.451C7.40059 8.305 7.21792 8.23167 6.99992 8.231C6.79325 8.231 6.61325 8.30467 6.45992 8.452C6.30659 8.59933 6.22992 8.782 6.22992 9C6.22992 9.20667 6.30659 9.38667 6.45992 9.54C6.61325 9.69333 6.79659 9.77 7.00992 9.77Z" fill="currentColor"/>
                        <path d="M0.961921 17C0.819921 17 0.700921 16.952 0.604921 16.856C0.508921 16.76 0.461254 16.641 0.461921 16.499C0.462588 16.357 0.510254 16.2383 0.604921 16.143C0.699588 16.0477 0.818588 16 0.961921 16H1.99992V2.116C1.99992 1.67133 2.15825 1.291 2.47492 0.975C2.79159 0.659 3.17159 0.500667 3.61492 0.5H12.3849C12.8289 0.5 13.2089 0.658333 13.5249 0.975C13.8409 1.29167 13.9993 1.67167 13.9999 2.115V16H15.0389C15.1803 16 15.2989 16.048 15.3949 16.144C15.4909 16.24 15.5386 16.359 15.5379 16.501C15.5373 16.643 15.4896 16.7617 15.3949 16.857C15.3003 16.9523 15.1813 17 15.0379 17H0.961921ZM12.9999 16V2.116C12.9999 1.936 12.9423 1.78833 12.8269 1.673C12.7116 1.55767 12.5643 1.5 12.3849 1.5H8.84592V1.016C9.46392 1.08467 9.97725 1.35 10.3859 1.812C10.7946 2.274 10.9993 2.81233 10.9999 3.427V14.739C10.9999 15.1417 10.8609 15.4993 10.5829 15.812C10.3049 16.1247 9.96259 16.3033 9.55592 16.348V16H12.9999ZM7.00992 9.77C7.22259 9.77 7.40225 9.69333 7.54892 9.54C7.69559 9.38667 7.76892 9.20333 7.76892 8.99C7.76892 8.77667 7.69525 8.597 7.54792 8.451C7.40059 8.305 7.21792 8.23167 6.99992 8.231C6.79325 8.231 6.61325 8.30467 6.45992 8.452C6.30659 8.59933 6.22992 8.782 6.22992 9C6.22992 9.20667 6.30659 9.38667 6.45992 9.54C6.61325 9.69333 6.79659 9.77 7.00992 9.77Z" fill="black" fill-opacity="0.2"/>
                      </svg>
                    </i>
                    <i v-else class="fa icon fs-2">
                      <svg width="22" height="17" viewBox="0 0 22 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <mask id="mask0_4995_31243" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="22" height="17">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M7.50024 1L21.0001 6V16H7.50024V1Z" fill="white" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M7.49992 1L1 6V16H7.49992" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M16.4997 16V10L11.9998 8.5V16" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M21.0001 16H7.50024" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </mask>
                        <g mask="url(#mask0_4995_31243)">
                          <path d="M-1 -6H22.9997V18H-1V-6Z" fill="currentColor"/>
                          <path d="M-1 -6H22.9997V18H-1V-6Z" fill="black" fill-opacity="0.2"/>
                        </g>
                      </svg>
                    </i>
                  </div>
                  <div class="door_card_content">
                    <span class="fs-4">{{  node.name }}</span>
                    <div class="d-flex align-items-center justify-content-center ms-auto">
                      <a v-if="doorsWithCardConfig.includes(node.id)" :key="index" class="btn btn-sm btn-icon shadow-none method_btn cursor-default">
                        <i class="bi bi-gear-fill text-white icon-hover-primary" ></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </template>
    </BaseTree>
  </div>

</template>

<script setup>
import {defineEmits, defineProps, onMounted, nextTick, ref, watch, computed} from 'vue';
import { useRoute, useRouter } from 'vue-router'
import Card from "@/components/Card.vue";
import Button from "@/components/Button.vue";
import { BaseTree } from '@he-tree/vue'
import '@he-tree/vue/style/default.css'
import '@he-tree/vue/style/material-design.css'
import PerimeterConfigModal from "@/Modules/Access/views/Config/components/PerimeterConfigModal.vue";
import AssignUsersModal from "@/Modules/Access/views/Config/components/AssignUsersModal.vue";
import {useAccessMethodUtils} from "@/Modules/Access/composables/accessMethodUtils";


const { getAccessMethod } = useAccessMethodUtils()
const route = useRoute()
const router = useRouter()

const selected = defineModel()
const emits = defineEmits(['reload'])

const props = defineProps({
  perimeters: {
    type: Array,
    required: true,
    default: []
  },
  doorsWithCardConfig: {
    type: Array,
    default: []
  },
  canEdit: {
    type: Boolean,
    default: true
  }
})

const tree = ref()
const treeData = ref(props.perimeters);
const currentSelected = ref({})


watch(() => props.perimeters, () => {
  treeData.value = props.perimeters
})

watch(() => treeData.value, () => {
  const node = findNodeById(treeData.value, selected.value)
  if(node) {
    nextTick(() => {
      expandPathToSelected(node)
    })
  }
}, { deep: true })

function toggleSelected(node) {
  router.replace({ query: { ...route.query, perimeter: node.id } });
  selected.value = node.id
  currentSelected.value = {
    id: node.id,
    name: node.name,
    isDoor: node.isDoor,
    accessMethods: [...node.accessMethods],
    hours: []
  }
}
function findNodeById(tree, id) {
  for (const node of tree) {
    for (const node of tree) {
      if (node.id === id) {
        return node
      }

      if (node.children && node.children.length) {
        const found = findNodeById(node.children, id)
        if (found) {
          return found
        }
      }
    }

    return null
  }
}

function expandPathToSelected(node) {
  if(tree.value) {
    tree.value.openNodeAndParents(node);
  }
}

onMounted(() => {

  const style = document.createElement('style');
  style.textContent = `.mtl-tree .tree-node:hover { background-color: transparent !important; }`;
  document.head.appendChild(style);
  if(route.query.perimeter) {
    const node = findNodeById(treeData.value, route.query.perimeter)
    if(node) {
      selected.value = route.query.perimeter
      currentSelected.value = {
        id: node.id,
        name: node.name,
        isDoor: node.isDoor,
        accessMethods: [...node.accessMethods],
        hours: [],
      }

      nextTick(() => {
        expandPathToSelected(node)
      })
    }
  }
})

</script>

<style scoped>

.doors {
  display: flex;
  align-items: center;
  min-width: 250px;
  width: 100%;
  cursor: pointer;
}

.open_icon_container {
  background-color: var(--bs-white);
  border-radius: 50%;
  box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.1)!important;
  height: 20px;
  width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
}

.doors:hover {
  background: none;
}

.doors.selected .open_icon_container {
  background-color: var(--bs-primary);
  border-radius: 50%;
  box-shadow: var(--bs-box-shadow-sm);
  height: 20px;
  width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
}


.doors.selected .open_icon_container .icon{
  color: var(--bs-white);
}

.door_icon_container {
  width: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--bs-gray-500);
  transition: background-color 0.2s;
  border-top-left-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}

.doors.selected .door_icon_container {
  background-color: var(--bs-white);
}


.doors .door_icon_container .icon {
  color: var(--bs-gray-700);
}

.doors.selected .door_icon_container .icon {
  color: var(--bs-primary);
}

.door_card_content {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0.5rem;
  transition: background-color 0.2s;
  background-color: transparent;
  color: var(--bs-gray-600);
  font-weight: 800;
}

.doors.selected .door_card_content {
  background-color: var(--bs-primary);
  color: var(--bs-white);
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}

.add_method_btn {
  background-color: transparent !important;
  border: 1px dashed var(--bs-gray-500)!important;
  color: var(--bs-gray-400)!important;
  box-shadow: none;
  margin-right: 5px;
}

.doors.selected .add_method_btn,
.doors.selected .door_card_content .add_method_btn {
  background-color: transparent !important;
  border: 1px dashed var(--bs-white)!important;
  color: var(--bs-white)!important;
  transition: border 0.2s, color 0.2s;
}

.doors.selected .add_method_btn i,
.doors.selected .door_card_content .add_method_btn i {
  color: var(--bs-white)!important;
}

.method_btn {
  background-color: var(--bs-gray-500);
  border: 1px solid var(--bs-gray-500)!important;
  color: var(--bs-white)!important;
  box-shadow: none;
  margin-right: 5px;
}

.doors.selected .method_btn,
.doors.selected .door_card_content .method_btn {
  background-color: var(--bs-white)!important;
  border: 1px dashed var(--bs-white)!important;
  color: var(--bs-primary)!important;
  transition: border 0.2s, color 0.2s;
}

.doors.selected .door_card_content .add_method_btn i.icon-hover-white,
.doors.selected .door_card_content .method_btn i.icon-hover-white {
  color: var(--bs-white)!important;
}

.doors.selected .door_card_content .add_method_btn i.icon-hover-primary,
.doors.selected .door_card_content .method_btn i.icon-hover-primary {
  color: var(--bs-primary)!important;
}

/* 0072CE33 */



</style>